Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleWistiaLoad = void 0;
var _utils = require("../../utils");
var isWistiaAdded = false;
var embedUrl = "https://fast.wistia.net/assets/external/E-v1.js";
var handleWistiaLoad = function handleWistiaLoad() {
  if (isWistiaAdded) {
    return;
  }
  (0, _utils.createScriptTag)(embedUrl, null);
  isWistiaAdded = true;
};
exports.handleWistiaLoad = handleWistiaLoad;